import { Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/globals/globals';
import { EnquiryByEnquiryNo } from 'src/app/shared/models/data/enquiryByEnquiryNo.model';
import { HeaderParametersValues } from 'src/app/shared/models/data/headerParametersValues.model';
import { NormGrade, NormGrades } from 'src/app/shared/models/data/normGrades.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftGridService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-grid.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { TeiasoftOdataService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-odata.service';
import { GridConfiguration } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
declare var $:any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  buttonsListSx: TTButton[] = new Array();
  buttonsListDx: TTButton[] = new Array();
  gridConfiguration: GridConfiguration = new GridConfiguration();
  gridFilterable: boolean = false;
  
  headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  statusSelected: string = 'all';
  enquiriesList: any[] = new Array();
  filteredEnquiriesList: any[] = new Array();
  defaultView: string = "GetAll?";
  action: string = "";
  enquiryByEnquiryNo: EnquiryByEnquiryNo = new EnquiryByEnquiryNo();
  mstOfferStatusList: SelectOption[] = new Array();
  unitSystemList: SelectOption[] = new Array();
  salesOfficeList: SelectOption[] = new Array();
  smsList: SelectOption[] = new Array();
  alloySurchargeList: SelectOption[] = new Array();
  orderReasonList: SelectOption[] = new Array();
  marketFamilyList: SelectOption[] = new Array();
  normGradesDataSet: NormGrade[] = new Array();
  rawMaterialGradeList: SelectOption[] = new Array();

  constructor(private teiasoftLoader: TeiasoftLoaderService, private backendService: BackendService, public globals: Globals,
    private teiasoftOdataService: TeiasoftOdataService, private teiasoftGridService: TeiasoftGridService, private translate: TranslateService,
    private utils: UtilsService) {
    this.getHeaderParametersValues();
  }

  ngOnInit(): void {
    
  }

  /* LOADING METHODS */
  getHeaderParametersValues() {
    this.teiasoftLoader.start();
    this.backendService.getHeaderParametersValues().subscribe(res => {
      this.headerParametersValues = new HeaderParametersValues();
      if (res) {
        res.countries?.sort((a,b) => {
          if ( a.countryName! < b.countryName! ){
            return -1;
          }
          if ( a.countryName! > b.countryName! ){
            return 1;
          }
          return 0;
        });
        this.headerParametersValues = res;
        this.createEnquirySelectOptions();
      }
    });

  }

  createEnquirySelectOptions(){
    this.mstOfferStatusList = new Array();
    for (var x=0; x < this.headerParametersValues.mstOfferStatus!.length; x++){
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.mstOfferStatus![x];
      _item.text = this.headerParametersValues.mstOfferStatus![x];
      this.mstOfferStatusList.push(_item);
    }

    this.unitSystemList = new Array();
    let _item: SelectOption = new SelectOption();
    _item.value = 'Metric';
    _item.text = this.translate.instant("enquiryBook.metric");
    this.unitSystemList.push(_item);
    _item = new SelectOption();
    _item.value = 'Imperial';
    _item.text = this.translate.instant("enquiryBook.imperial");
    this.unitSystemList.push(_item);

    this.salesOfficeList = new Array();
    for (var x=0; x < this.headerParametersValues.salesOffices!.length; x++){
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.salesOffices![x].officeId;
      _item.text = this.headerParametersValues.salesOffices![x].officeCode!;
      this.salesOfficeList.push(_item);
    }

    this.smsList = new Array();
    for (var x=0; x < this.headerParametersValues.sms!.length; x++){
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.sms![x].smsId;
      _item.text = this.headerParametersValues.sms![x].name!;
      this.smsList.push(_item);
    }

    this.alloySurchargeList = new Array();
    _item = new SelectOption();
    _item.value = true;
    _item.text = this.translate.instant("noTranslations.yes");
    this.alloySurchargeList.push(_item);
    _item = new SelectOption();
    _item.value = false;
    _item.text = this.translate.instant("noTranslations.no");
    this.alloySurchargeList.push(_item);

    this.orderReasonList = new Array();
    _item = new SelectOption();
    _item.text = "Stock";
    _item.value = "Stock";
    this.orderReasonList.push(_item);

    _item = new SelectOption();
    _item.text = "Project";
    _item.value = "Project";
    this.orderReasonList.push(_item);

    this.marketFamilyList = new Array();
    for (var x=0; x < this.headerParametersValues.marketFamily!.length; x++){
      let _item: SelectOption = new SelectOption();
      _item.value = this.headerParametersValues.marketFamily![x].marketFamilyId;
      _item.text = this.headerParametersValues.marketFamily![x].name!;
      this.marketFamilyList.push(_item);
    }

    this.checkUserConfiguration();
  }

  checkUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === 'EnquiryBook');
    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    }

    this.buildButtonsList();
  }

  buildButtonsList() {
    this.buttonsListSx = new Array();
    /* ALL */
    let _item: TTButton = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "allEnquiries";
    _item.action = "filter|GetAll";
    _item.type = "toggle";
    _item.toggleText = 'all';
    _item.state = (this.gridConfiguration.defaultFilterView == 'GetAll' || this.gridConfiguration.defaultFilterView == '' || !this.gridConfiguration.defaultFilterView) ? 'pressed' : '';
    this.buttonsListSx.push(_item);

    /* MINE */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 1;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "myEnquiries";
    _item.action = "filter|GetMy";
    _item.type = "toggle";
    _item.toggleText = 'my';
    _item.state = this.gridConfiguration.defaultFilterView == 'GetMy' ? 'pressed' : '';
    this.buttonsListSx.push(_item);

    /* OFFICE */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = '';
    _item.id = 2;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "officeEnquiries";
    _item.action = "filter|GetOffice";
    _item.type = "toggle";
    _item.toggleText = 'office';
    _item.state = this.gridConfiguration.defaultFilterView == 'GetOffice' ? 'pressed' : '';
    this.buttonsListSx.push(_item);


    /* ADD ENQUIRY */
    this.buttonsListDx = new Array();
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-plus';
    _item.id = 0;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "addEnquiry";
    _item.action = "add";
    _item.type = "";
    _item.state = '';
    this.buttonsListDx.push(_item);

    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 1;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsListDx.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 2;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsListDx.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 3;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsListDx.push(_item);

    this.getEnquiries();
  }

  getEnquiries(){
    this.teiasoftOdataService.getEnquiries(this.defaultView).subscribe(res => {
      this.enquiriesList = new Array();
      this.enquiriesList = res.value!;
      this.filteredEnquiriesList = new Array();
      this.filteredEnquiriesList = JSON.parse(JSON.stringify(this.enquiriesList));
      this.getNormGrades();
    });
  }

  getNormGrades(){
    this.backendService.getNormGrades([]).subscribe(res => {
      if (res && res.normGrades){
          this.normGradesDataSet = new Array();
          this.normGradesDataSet = res.normGrades!
          .slice() // Create a shallow copy of the array to avoid modifying the original array
            .sort((a: any, b:any) => {
            let nameA:string = a["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
            let nameB:string = b["normGradeCode"]!.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            // names must be equal
            return 0;
            }) // Sort by the 'score' property in descending order
            .slice(0, 100); // Take the top 100 records

          this.getRawMaterialGrades([]);
        }
    });
  }

  getRawMaterialGrades(normGradeIds: number[]){
    this.backendService.getRawMaterialGradesForEnquiry(normGradeIds).subscribe(res => {
      this.teiasoftLoader.stop();
      this.rawMaterialGradeList = new Array();
      for (var x=0; x < res.rawMaterialGrades!.length; x++){
        let _item: SelectOption = new SelectOption();
        _item.text = res.rawMaterialGrades![x].toString();
        _item.value = res.rawMaterialGrades![x].toString();
        this.rawMaterialGradeList.push(_item);
      }
    });
  }

  /* EVENTS */
  onBtnToolbarClick(btn: TTButton) {
    /* ALL ENQUIRIES / MY ENQUIRIES / OFFICE ENQUIRIES */
    if (btn.action!.indexOf('filter') != -1) {
      let _temp: string[] = new Array();
      _temp = btn.action!.split("|");
      this.gridConfiguration.defaultFilterView = _temp[1];
      //this.onUpdateConfiguration(this.gridConfiguration);
      this.defaultView = _temp[1] + "?";
      this.teiasoftLoader.start();
      this.getEnquiries();
    }

    /* ADD ENQUIRY */
    if (btn.action == 'add') {
     /*  this.isDuplicate = false;
      this.buildAddEnquiryForm('add');
      this.buildDialogButtons();
      this.dialogTitle = this.translate.instant("enquiryBook.add");
      this.dialogIcon = "fal fa-plus";
      this.showAddDialog = true; */
    }

    /* SHOW SETTINGS GRID */
    if (btn.action == 'showSettingsGrid') {
     // this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
     /*  this.gridFilterable = true;
      this.buildButtonsList(); */
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
    /*   this.gridFilterable = false;
      this.buildButtonsList(); */
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
    /*   this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid(); */
    }

  }

  /* METHODS */
  getEnquiryByEnquiryNo(enquiryNo: string){
    this.teiasoftLoader.start();
    this.backendService.getEnquiryByEnquiryNo(enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.action = 'edit';
      this.enquiryByEnquiryNo = new EnquiryByEnquiryNo();
      this.enquiryByEnquiryNo = res;
    });
  }

  /**
   * SELECT MSTSTATUS FOR ENQUIRY FILTER
   * @param status 
   */
  onSelectStatus(status: string){
    this.statusSelected = status;
    this.filteredEnquiriesList = new Array();
    if (status != 'all')
      this.filteredEnquiriesList = this.enquiriesList.filter(x => x.MstOfferStatus == status);
    else
      this.filteredEnquiriesList = JSON.parse(JSON.stringify(this.enquiriesList));
  }

  getIcon(category:string, data: any):string{
    return this.teiasoftGridService.calculateItemsValidityForHome(category, data);
  }

  countForStatus(status: string): number{
    return this.enquiriesList.filter(x => x.MstOfferStatus == status).length;
  }

  onSelectEnquiry(enquiryNo: string, status: string, i:number){
    for (var x=0; x < this.filteredEnquiriesList.length; x++){
      $('#enquiry_' + x).removeClass("enquiry-active");
    }

    $('#enquiry_' + i).addClass("enquiry-active");

    if (status.toLowerCase() == 'header'){
      alert("Create new version?");
    } else {
      this.getEnquiryByEnquiryNo(enquiryNo);
    }
    
  }

  /* UTILITIES */
  isEven(n:number): boolean{
    return n % 2 == 0;
  }
}
